import { createRoutine } from "redux-saga-routines";

export const getStreamAliasesRoutine = createRoutine('GET_STREAMS_ALISES');